module.exports = __webpack_public_path__ + "static/media/Steve_Y.8cd06983.jpg";